import { FactoryIcon, InfoIcon } from '@phosphor-icons/react';
import { Badge, Tooltip } from '@skupreme/shared/ui';
import { SupplierItemsHelpText } from '@utility/constants/strings';
import { flagImages } from '../legacy-bridge';
import type { CartonRow } from '../lib/rows';

/** Who makes the item, by name and country. */
export function SupplierBadges({ suppliers }: Pick<CartonRow, 'suppliers'>) {
  if (!suppliers.length) return null;

  return (
    <span className="sk:flex sk:flex-wrap sk:items-center sk:gap-1">
      {suppliers.map(supplier => {
        const flag = supplier.region
          ? flagImages[supplier.region.toUpperCase()]
          : undefined;

        return (
          <Badge key={supplier.id}>
            <span className="sk:inline-flex sk:items-center sk:gap-1">
              {flag ? (
                <img
                  src={flag}
                  alt=""
                  className="sk:h-2.5 sk:w-3.5 sk:rounded-xs sk:object-cover"
                />
              ) : (
                <FactoryIcon size={10} aria-hidden />
              )}
              {supplier.name}
            </span>
          </Badge>
        );
      })}
      {suppliers.length > 1 ? (
        <Tooltip content={SupplierItemsHelpText.multipleSupplierInfo}>
          <span className="sk:inline-flex sk:text-fg-tertiary">
            <InfoIcon size={12} aria-label="Multiple suppliers" />
          </span>
        </Tooltip>
      ) : null}
    </span>
  );
}
